import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle, MapPin, FileText, HardHat, CheckCircle2 } from 'lucide-react';

const steps = [
  {
    number: '01',
    icon: MessageCircle,
    title: 'Consultation',
    description: 'Tell us about your project and requirements.',
  },
  {
    number: '02',
    icon: MapPin,
    title: 'Site Visit',
    description: 'We assess the location and feasibility.',
  },
  {
    number: '03',
    icon: FileText,
    title: 'Planning & Estimate',
    description: 'We develop the scope, plan and cost.',
  },
  {
    number: '04',
    icon: HardHat,
    title: 'Construction',
    description: 'Our team manages the build process.',
  },
  {
    number: '05',
    icon: CheckCircle2,
    title: 'Handover',
    description: 'Final inspection and project completion.',
  },
];

export function ProcessSection() {
  return (
    <section className="bg-[#F8F9FB] py-10 md:py-20">
      <div className="container-custom">
        <div className="text-center mb-8 md:mb-10">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="flex items-center justify-center gap-2.5 mb-4"
          >
            <div className="w-8 h-px bg-amber-500" />
            <span className="text-amber-500 text-[11px] font-bold uppercase tracking-[0.22em]">Our Process</span>
            <div className="w-8 h-px bg-amber-500" />
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-3xl md:text-4xl font-black text-slate-900 mb-3"
          >
            From Plan to Completion
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            viewport={{ once: true }}
            className="text-slate-500 max-w-xl mx-auto"
          >
            A simple, transparent process to bring your vision to life.
          </motion.p>
        </div>

        <div className="flex flex-col md:flex-row items-stretch md:items-start justify-between gap-8 md:gap-2">
          {steps.map((step, index) => (
            <div key={step.title} className="flex items-center md:contents">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="flex flex-col items-center text-center flex-1 md:px-2"
              >
                <div className="relative mb-4">
                  <div className="w-16 h-16 rounded-full bg-amber-400 flex items-center justify-center shadow-lg shadow-amber-500/30">
                    <step.icon className="w-7 h-7 text-slate-900" />
                  </div>
                  <span className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-slate-900 text-amber-400 text-[11px] font-black flex items-center justify-center">
                    {step.number}
                  </span>
                </div>
                <h3 className="font-bold text-slate-900 text-base mb-1.5">{step.title}</h3>
                <p className="text-slate-500 text-sm leading-relaxed max-w-[160px]">{step.description}</p>
              </motion.div>

              {index < steps.length - 1 && (
                <ArrowRight className="hidden md:block w-5 h-5 text-amber-400 shrink-0 mt-6" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
